import "@/index.css";
import "@/App.css";
import { LanguageProvider } from './context/LanguageContext';
import { PerfumeProvider } from './context/PerfumeContext';
import { PerfumeLab } from './components/PerfumeLab';

function App() {
  return (
    <LanguageProvider>
      <PerfumeProvider>
        <PerfumeLab />
      </PerfumeProvider>
    </LanguageProvider>
  );
}

export default App;
